import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DiagnosisService } from '../diagnosis.service';
import { ExamsService } from '../exams.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {AutotextService} from '../autotext.service';
import { LoginService } from '../login.service';
import { Observable,Subscription } from 'rxjs';

@Component({
    selector: 'app-diagnoses',
    templateUrl: './diagnoses.component.html',
    styleUrls: ['./diagnoses.component.scss'],
    standalone: false
})
export class DiagnosesComponent implements OnInit,OnDestroy {

  @Input('group') Group: string;
  @Input('form') Form: UntypedFormControl;
  @Input('formGroup') formGroup: UntypedFormGroup;

  @Input('text') Text: UntypedFormControl;
  @Input('textStress') TextStress: UntypedFormControl;
  // TextStress: FormControl;
  @Input('autoid') ATsID: number;
  @Input('autoidstress') ATsIDStress: number;
  lastDiagnosis: string;



  
  @Input('insummary') insummary:boolean;
  @Input('inpregnancy') inpregnancy:boolean;
  @Input('close') closed: Observable<void>;
  @Input('textonly') textOnly: boolean = false;

  diag1: number;
  diag2: number;
  diag3: number;

  Diagnoses = [];
  Indication = [];
  private closeSubscription: Subscription;

  constructor(public ds: DiagnosisService, public es: ExamsService, public atS: AutotextService, public ls: LoginService) { }

  ngOnInit() {
    //gererate list after the form is loaded
    this.es.formLoaded$.subscribe(() => {
      if(this.insummary){
        this.Diagnoses = this.ds.BuildList(this.Form.value, true);
      }else{
        this.Diagnoses = this.ds.BuildList(this.Form.value);
      }
    });
    this.ds.inAnatomy = this.Group === 'chestFetal';
    this.ds.isFetal = this.es.ExamType === 'Fetal Echo';
    this.ds.inSummary = this.Group === 'summary';
    if(this.ds.isFetal){
      this.ATsID= 43;
    }
    if (!this.es.isClosed) {
      this.es.getLastSummary().subscribe((data) => {
        if(data['summary'] && data['summary']["Anomalies"])
          this.lastDiagnosis = data['summary']["Anomalies"];
      }, (err) => {
        console.log(err);
      });
    }
    if(closed){
      this.closeSubscription = this.closed.subscribe(()=>{
        this.Text.disable({emitEvent: false});
        this.TextStress.disable({emitEvent: false});

      })
    }
  }
  addLastDiagnosis() {
    if (this.formGroup.get("Anomalies").value)
      this.formGroup.get("Anomalies").setValue(this.formGroup.get("Anomalies").value + this.lastDiagnosis);
    else
      this.formGroup.get("Anomalies").setValue(this.lastDiagnosis);
  }

  ngOnDestroy(): void {
      if(this.closeSubscription)
        this.closeSubscription.unsubscribe();
  }

  addDiagnosis() {
    if (this.diag3) {
      if(this.textOnly)
        this.Text.setValue((this.Text.value  ? this.Text.value + '\n': '')  + this.ds.getName(this.diag2) + ' > ' + this.ds.getName(this.diag3));
      else
        this.Diagnoses.push([this.diag3, this.ds.getName(this.diag1) + ' > ' + this.ds.getName(this.diag2) + ' > ' + this.ds.getName(this.diag3)]);
      this.diag1 = null;
      this.diag2 = null;
      this.diag3 = null;
      var str = this.ds.isFetal ? 'summary' : this.Group;
      this.ds.save(this.Diagnoses, str);
    }
    else
      if (this.diag2 && this.ds.getList(this.diag2).length == 0) {
        if(this.textOnly)
          this.Text.setValue((this.Text.value  ? this.Text.value + '\n': '') + this.ds.getName(this.diag2));
        else
          this.Diagnoses.push([this.diag2, this.ds.getName(this.diag1) + ' > ' + this.ds.getName(this.diag2)]);
        this.diag1 = null;
        this.diag2 = null;
        var str = this.ds.isFetal ? 'summary' : this.Group;
        this.ds.save(this.Diagnoses, str);
      }
  }

  removeDiagnosis(id: number) {
    if (this.es.isClosed)
      return;
    for (let i = 0; i < this.Diagnoses.length; i++) {
      if (this.Diagnoses[i][0] == id) {
        this.Diagnoses.splice(i, 1);
        if (this.ds.isFetal) {
          this.ds.save(this.Diagnoses, 'summary')
        } else {
          this.ds.save(this.Diagnoses, this.Group);
        }
      }
    }
  }

  getDiag(d){
    if(d[1].split(">").length > 2){
      return d[1].split(">")[2]
    }
    return d[1].split(">")[1]
  }

}
